import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, Download } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export function PaymentHistoryCard({ paymentHistory, formatDate }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileText className="h-5 w-5 text-blue-600" />
          Payment History & Invoices
        </CardTitle>
      </CardHeader>
      <CardContent>
        {paymentHistory.length === 0 ? (
          <p className="text-center text-gray-500 py-8">No payment history yet</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b">
                  <th className="text-left py-3 px-4 text-sm font-medium text-gray-500">Date</th>
                  <th className="text-left py-3 px-4 text-sm font-medium text-gray-500">Description</th>
                  <th className="text-left py-3 px-4 text-sm font-medium text-gray-500">Amount</th>
                  <th className="text-left py-3 px-4 text-sm font-medium text-gray-500">Status</th>
                  <th className="text-left py-3 px-4 text-sm font-medium text-gray-500">Invoice</th>
                </tr>
              </thead>
              <tbody>
                {paymentHistory.map((payment) => (
                  <tr key={payment.id || payment.invoice_id || `${payment.date}-${payment.amount}`} className="border-b hover:bg-gray-50">
                    <td className="py-3 px-4 text-sm">{formatDate(payment.date)}</td>
                    <td className="py-3 px-4 text-sm">{payment.description}</td>
                    <td className="py-3 px-4 text-sm font-medium">₹{payment.amount}</td>
                    <td className="py-3 px-4">
                      <span className={`text-xs px-2 py-1 rounded-full ${payment.status === 'paid' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                        {payment.status}
                      </span>
                    </td>
                    <td className="py-3 px-4">
                      {payment.invoice_id ? (
                        <Button 
                          variant="ghost" 
                          size="sm"
                          onClick={() => {
                            window.open(`${API}/invoices/${payment.invoice_id}/download`, '_blank');
                          }}
                          data-testid={`download-invoice-${payment.invoice_id}`}
                        >
                          <Download className="h-4 w-4 mr-1" />
                          PDF
                        </Button>
                      ) : (
                        <span className="text-xs text-gray-400">N/A</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default PaymentHistoryCard;
